module.exports = __webpack_public_path__ + "media/images/map-icons/carASelected@3x-22d86a10495f4c65ae9f84adac9ebebb.png";